(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const data = JSON.parse(root.querySelector('[data-variant-data]').textContent);
    const select = root.querySelector('[data-variant-select]');
    const image = root.querySelector('.main-product-image');
    const links = [...root.querySelectorAll('[data-image-link]')];
    const changeImage = (src, id, alt) => {
      if (!image || !src) return;
      image.removeAttribute('srcset');
      image.src = src;
      if (alt) image.alt = alt;
      links.forEach(link => String(link.dataset.imageId) === String(id) ? link.setAttribute('aria-current', 'true') : link.removeAttribute('aria-current'));
    };
    const update = (writeUrl) => {
      const variant = data.variants.find(item => String(item.id) === select.value);
      const available = Boolean(variant?.available);
      root.querySelector('[data-add]').disabled = !available;
      root.querySelector('[data-add-label]').textContent = available ? data.labels.add : data.labels.sold;
      root.querySelector('[data-availability]').textContent = available ? data.labels.available : data.labels.unavailable;
      if (!variant) return;
      root.querySelector('[data-price]').textContent = variant.price;
      const compare = root.querySelector('[data-compare]');
      compare.hidden = !variant.compare;
      compare.textContent = variant.compare || '';
      const sale = root.querySelector('[data-sale]');
      if (sale) {
        sale.hidden = !variant.saving;
        root.querySelector('[data-saving]').textContent = variant.saving || '';
      }
      const thumb = links.find(link => String(link.dataset.imageId) === String(variant.imageId));
      changeImage(variant.image, variant.imageId, thumb?.dataset.alt);
      if (writeUrl) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      }
    };
    select.addEventListener('change', () => update(true));
    root.querySelector('.product-form').addEventListener('submit', event => {
      if (!data.variants.find(item => String(item.id) === select.value)?.available) { event.preventDefault(); update(false); }
    });
    links.forEach(link => link.addEventListener('click', event => { if (image) { event.preventDefault(); changeImage(link.href, link.dataset.imageId, link.dataset.alt); } }));
    update(false);
  };
  const boot = () => document.querySelectorAll('[data-product-section]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mobile-nav[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.mobile-nav[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
})();
